import { IMessagesTypeEnum } from "@ryde/controls";

import { ILandingMessagesDto } from "../models";

export const createMessage = (
  messages: string[],
  type?: IMessagesTypeEnum,
): ILandingMessagesDto => {
  return {
    messages,
    type: type || IMessagesTypeEnum.ERROR,
  };
};

export const isServerMessageHasError = (
  serverMessage?: ILandingMessagesDto,
): boolean => {
  return (
    !!serverMessage?.messages?.length &&
    serverMessage.type === IMessagesTypeEnum.ERROR
  );
};
